export function Parceria() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-20 bg-dark relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/[0.02] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold">
            Parceria Exclusiva
          </span>
        </div>

        <div className="border border-gold/20 rounded-2xl p-8 md:p-14 bg-gradient-to-br from-dark-light/60 to-dark/80 backdrop-blur-sm hover:shadow-[0_8px_40px_rgba(212,175,55,0.12)] transition-all duration-700 group">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14">
            {/* Logo area */}
            <div className="flex-shrink-0">
              <div className="w-32 h-32 md:w-36 md:h-36 rounded-2xl border-2 border-gold/30 flex items-center justify-center bg-[#F5F1E8] p-4 group-hover:border-gold/60 transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/ddc6dbc53596691e38d04fbd711f3d87/d82d8ae30519078a9ada209e73d906ea.png" 
                  alt="Adianta Arte" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 text-center md:text-left space-y-4 md:space-y-5">
              <h3 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                Adianta <span className="text-gold">Arte</span>
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-xl">
                Parceria exclusiva que une forças para potencializar a cultura, a arte e o desenvolvimento social. Juntos, transformamos projetos em impacto real nas comunidades.
              </p>
              <div className="w-12 h-0.5 bg-gold/40 mx-auto md:mx-0"></div>
            </div>

            {/* CTA */}
            <div className="flex-shrink-0">
              <a
                href="https://www.adiantaarte.com.br"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 px-7 py-3 border border-gold/40 text-gold rounded-full text-xs md:text-sm font-semibold uppercase tracking-wider hover:bg-gold hover:text-black transition-all duration-400 whitespace-nowrap cursor-pointer group/btn"
              >
                Conheça
                <i className="ri-external-link-line text-sm group-hover/btn:translate-x-0.5 transition-transform duration-300"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Subtle tagline */}
        <p className="text-center mt-8 text-gray-600 text-xs tracking-widest uppercase">
          Cultura &bull; Arte &bull; Impacto Social
        </p>
      </div>
    </section>
  );
}
